import { useEffect, useRef, useState } from "react";
import { Formik, Form, FormikProps } from "formik";
import { FormikInjectedDropDown } from "./FormikInjectedDropDown";
import { GiveValuestoFormComponent } from "common/components/GiveValuestoFormComponent";
import {
  Box,
  Flex,
  Heading,
  Radio,
  RadioGroup,
  Stack,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import TimePicker from "./TimePicker";
import { FormikInjectedCalender } from "./FormikInjectedCalender";
import { MediumBtn } from "common/components/Buttons/MediumBtn";
import { NavLink } from "react-router-dom";
import { ILandingFormValues } from "types/public/ILandingFormValues";
import { ReadLocalAndUpdateForm } from "./ReadLocalAndUpdateForm";
import {
  useGetCityByIdQuery,
  useGetCountryByIdQuery,
  useGetFormQuery,
} from "api/public.api";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { formSteps } from "common/enums/formSteps";
import { IGetFormData } from "types/public/API/getForm/IGetFormData";
import { TFormItemData } from "types/public/API/getForm/TFormItemData";
import { ajaxWarningAlert } from "utils/alert";
import {
  useAppDispatch,
  useAppSelector,
} from "common/services/reduxToolkitHooks";
import { addFormData } from "state/public/publicReducer";
import { FillFormWithLocalStorage } from "./FillFormWithLocalStorage";
import { FillFormWithRedux } from "./FillFormWithRedux";

const requiredErrorMSG = () =>
  ajaxWarningAlert("همه‌ی گزینه ها را انتخاب کنید", undefined, undefined, {
    showCancelButton: false,
  });

const localStorageFormValues = localStorage.getItem("landingFormValues");
const parsedLocalStorageFormValues =
  localStorageFormValues && JSON.parse(localStorageFormValues);

export let initialValues: ILandingFormValues = parsedLocalStorageFormValues || {
  gradeOptions: "",
  activityCategoryOptions: "",
  serviceDepartmentOptions: "",
  visitSubjectOptions: "",
  visitorRelationOptions: "",
  province: "",
  city: "",
  selectedDate: "",
  selectedTime: "",
};
window.dispatchEvent(new Event("storage"));
function LandingForm() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [formValues, setformValues] = useState(initialValues);
  const [selectedProvince, setSelectedProvince] = useState<number>();
  const [step, setStep] = useState(formSteps.initial);
  const formRef = useRef<FormikProps<ILandingFormValues>>(null);
  const { data: provinces } = useGetCountryByIdQuery();
  const { data: cities } = useGetCityByIdQuery(selectedProvince || skipToken);
  const { data: formItemsData } = useGetFormQuery();

  const {
    gradeOptions,
    activityCategoryOptions,
    serviceDepartmentOptions,
    visitSubjectOptions,
    visitorRelationOptions,
  } = formItemsData ?? {};
  const [standardProvinces, setStandardProvinces] = useState([
    {
      id: 0,
      label: "",
    },
  ]);

  const [standardCities, setStandardCities] = useState([
    {
      id: 0,
      label: "",
    },
  ]);
  const [standardVisitorRelation, setStandardVisitorRelation] = useState([
    {
      id: 0,
      label: "",
    },
  ]);
  useEffect(() => {
    let tmpStandardVisitorRelation = visitorRelationOptions?.map(
      ({ id, faTitle }) => ({ id: id, label: faTitle })
    );
    tmpStandardVisitorRelation &&
      setStandardVisitorRelation(tmpStandardVisitorRelation);
  }, [visitorRelationOptions]);

  useEffect(() => {
    console.log("formValues", formValues);
    parsedLocalStorageFormValues && setformValues(parsedLocalStorageFormValues);
  }, [localStorageFormValues]);

  useEffect(() => {
    formValues.province && setSelectedProvince(+formValues.province);
  }, [formValues.province]);

  useEffect(() => {
    provinces &&
      setStandardProvinces(
        provinces.map((province) => ({
          id: province.id,
          label: province.faTitle,
        }))
      );
  }, [provinces]);

  useEffect(() => {
    if (selectedProvince !== undefined) {
      if (cities) {
        let tmpStandardCities = cities.map((city) => ({
          id: city.id,
          label: city.faTitle,
        }));
        setStandardCities(tmpStandardCities);
      }
    }
  }, [cities]);

  const cancelClickHandler = () => {
    //should set form values to form (so it shows the changes or delete values alltogether )
    setStep(formSteps.initial);
  };
  const numberOfselectedValues = (Object.values(formValues) as string[]).filter(
    (item) => !!item
  ).length;
  const isEducational = +formValues.visitorRelationOptions === 1;
  const occuCategNotOther = +formValues.activityCategoryOptions !== 3;
  // let allIsChecked=
  const step1FormIsValid =
    (isEducational && occuCategNotOther && numberOfselectedValues >= 7) ||
    (isEducational &&
      +formValues.activityCategoryOptions === 3 &&
      numberOfselectedValues >= 6) ||
    (+formValues.visitorRelationOptions !== 1 && numberOfselectedValues >= 5);

  const step2FormIsValid =
    (isEducational && occuCategNotOther && numberOfselectedValues === 8) ||
    (isEducational &&
      +formValues.activityCategoryOptions === 2 &&
      numberOfselectedValues === 7) ||
    (+formValues.visitorRelationOptions !== 0 && numberOfselectedValues === 6);

  useEffect(() => {
    step1FormIsValid && setStep(formSteps.preSubmit);
  }, [formValues]);

  function makeRadioGroup(
    radioData: TFormItemData,
    radioName: keyof IGetFormData,
    formikrops: FormikProps<ILandingFormValues>
  ) {
    return (
      <RadioGroup name={radioName} value={formikrops.values[radioName]}>
        <Stack
          align="start"
          direction={{ base: "column", md: "row" }}
          width={{ base: "11.1rem", sm: "11.1rem", md: "32rem" }}
        >
          {radioData.map(({ faTitle, id }) => (
            <Radio value={"" + id}>{faTitle}</Radio>
          ))}
        </Stack>
      </RadioGroup>
    );
  }

  function onSubmitFunc(_: unknown) {
    if (step2FormIsValid) {
      const token = localStorage.getItem("Access-token");
      if (token) {
        localStorage.removeItem("landingFormValues");

        navigate("/user");
      } //should send request to server and if successful

      if (!token) {
        localStorage.setItem("landingFormValues", JSON.stringify(formValues));
        dispatch(addFormData(formValues));

        navigate("/auth/signin");
      }
    } else {
      requiredErrorMSG();
    }

    console.log("Formik formValues", formValues);
    console.log("submiiiiiit");
  }
  function initialLVLCancelClickHandler() {
    navigate("/");
  }
  function onInitialLVLSubmit() {
    if (step1FormIsValid) return setStep(formSteps.preSubmit);
    requiredErrorMSG();
  }

  const today = new Date();
  let tomorrow = new Date();
  let aTomorrow = new Date();
  let _2aTomorrow = new Date();
  let lastDay = new Date();
  let bLastDay = new Date();

  tomorrow.setDate(today.getDate() + 1);
  aTomorrow.setDate(today.getDate() + 2);
  _2aTomorrow.setDate(today.getDate() + 3);
  lastDay.setDate(today.getDate() - 1);
  bLastDay.setDate(today.getDate() - 2);
  let availableDays = [tomorrow, _2aTomorrow];
  console.log("bLastDay", typeof bLastDay);

  return (
    <Flex className="landingForm-container">
      <Formik
        initialValues={initialValues}
        innerRef={formRef}
        onSubmit={() => {}}
      >
        {(props: FormikProps<ILandingFormValues>) => (
          <Form onChange={props.handleChange}>
            <GiveValuestoFormComponent setformValues={setformValues} />
            <FillFormWithLocalStorage />
            <FillFormWithRedux />
            <Box p="0.75rem">
              {step === 0 && (
                <>
                  <Flex justifyContent="center">
                    <Flex
                      justifyContent="space-between"
                      direction={{ base: "column", md: "row" }}
                      mb="4"
                      px="2rem"
                      h={{ base: "8rem", md: "2.5rem" }}
                      w={{ base: "15rem", md: "737px" }}
                    >
                      <FormikInjectedDropDown
                        btnTxt="استان"
                        name="province"
                        items={standardProvinces}
                        value={formValues.province}
                      />

                      <FormikInjectedDropDown
                        btnTxt="شهر"
                        name="city"
                        items={standardCities}
                        value={formValues.city}
                        // className
                      />
                      <FormikInjectedDropDown
                        btnTxt="رابطه مراجعه کننده"
                        name="visitorRelationOptions"
                        items={standardVisitorRelation}
                        value={formValues.visitorRelationOptions}
                      />
                    </Flex>
                  </Flex>

                  {formValues.visitorRelationOptions === "1" ? (
                    <>
                      <Stack
                        direction="row"
                        flexWrap={{ base: "wrap", sm: "nowrap" }}
                        mb={4}
                        px="2.9rem"
                      >
                        <Heading
                          size="sm"
                          width="8.4rem"
                          pb="5"
                          display="inline-block"
                        >
                          دسته فعالیت:
                        </Heading>
                        {activityCategoryOptions &&
                          makeRadioGroup(
                            activityCategoryOptions,
                            "activityCategoryOptions",
                            props
                          )}
                      </Stack>
                      {formValues.activityCategoryOptions === "1" ? (
                        <Stack
                          direction="row"
                          flexWrap={{ base: "wrap", sm: "nowrap" }}
                          mb={4}
                          px="2.9rem"
                        >
                          <Heading
                            size="sm"
                            width="8.4rem"
                            pb="5"
                            display="inline-block"
                          >
                            مقطع تحصیلی مربوطه:
                          </Heading>
                          {gradeOptions &&
                            makeRadioGroup(gradeOptions, "gradeOptions", props)}
                        </Stack>
                      ) : formValues.activityCategoryOptions === "2" ? (
                        <Stack
                          direction="row"
                          flexWrap={{ base: "wrap", sm: "nowrap" }}
                          mb={4}
                          px="2.9rem"
                        >
                          <Heading
                            size="sm"
                            width="8.4rem"
                            pb="5"
                            display="inline-block"
                          >
                            دایره خدمت مربوطه :
                          </Heading>
                          {serviceDepartmentOptions &&
                            makeRadioGroup(
                              serviceDepartmentOptions,
                              "serviceDepartmentOptions",
                              props
                            )}
                        </Stack>
                      ) : null}
                    </>
                  ) : null}

                  <Stack
                    direction="row"
                    flexWrap={{ base: "wrap", sm: "nowrap" }}
                    mb={4}
                    px="2.9rem"
                  >
                    <Heading
                      size="sm"
                      width="8.4rem"
                      pb="5"
                      display="inline-block"
                    >
                      موضوع مراجعه :
                    </Heading>
                    {visitSubjectOptions &&
                      makeRadioGroup(
                        visitSubjectOptions,
                        "visitSubjectOptions",
                        props
                      )}
                  </Stack>
                  <Flex justifyContent="center" mt={7}>
                    <FormikInjectedCalender
                      availableDays={availableDays}
                      setStep={setStep}
                      canChangeStep={
                        true
                        //step1FormIsValid
                      }
                      value={formValues.selectedDate}
                    />
                  </Flex>
                </>
              )}
              {step === formSteps.initial && (
                <>
                  <Flex justifyContent="end" mt="25px" ml="15px">
                    <MediumBtn
                      bg="red.300"
                      _hover={{
                        bg: "red.200",
                      }}
                      _active={{
                        bg: "red.400",
                      }}
                      ml={2}
                      onClick={initialLVLCancelClickHandler}
                    >
                      انصراف
                    </MediumBtn>

                    <MediumBtn
                      type="submit"
                      onClick={onInitialLVLSubmit}
                      _disabled={{
                        bg: "teal.100",
                      }}
                      isDisabled={!step1FormIsValid}
                    >
                      مرحله بعد
                    </MediumBtn>
                  </Flex>
                </>
              )}
              {step === formSteps.preSubmit && (
                <>
                  <TimePicker
                    name="selectedTime"
                    setStep={setStep}
                    value={props.values.selectedTime}
                  />
                  <Flex justifyContent="end" mt="25px" ml="15px">
                    <MediumBtn
                      bg="red.300"
                      _hover={{
                        bg: "red.200",
                      }}
                      _active={{
                        bg: "red.400",
                      }}
                      ml={2}
                      onClick={cancelClickHandler}
                    >
                      انصراف
                    </MediumBtn>

                    <MediumBtn type="submit" onClick={onSubmitFunc}>
                      ثبت نوبت
                    </MediumBtn>
                  </Flex>
                </>
              )}
            </Box>
          </Form>
        )}
      </Formik>
    </Flex>
  );
}

export default LandingForm;
